"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nav = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
exports.Nav = function (_a) {
    var _b;
    var items = _a.items, activeItemId = _a.activeItemId, onActiveTabChange = _a.onActiveTabChange;
    var _c = __read(React.useState((_b = items === null || items === void 0 ? void 0 : items[0]) === null || _b === void 0 ? void 0 : _b.id), 2), activeNavItemId = _c[0], setActiveNavItemId = _c[1];
    React.useEffect(function () {
        if (activeItemId) {
            setActiveNavItemId(activeItemId);
        }
    }, [activeItemId]);
    var handleClick = function (item) {
        setActiveNavItemId(item.id);
        if (onActiveTabChange) {
            onActiveTabChange(item);
        }
    };
    return (React.createElement("div", null,
        React.createElement("nav", { className: "tk-nav" },
            React.createElement("ul", { className: "tk-nav--tabs" }, items.map(function (item) { return (React.createElement("li", { key: item.id, onClick: function () { return handleClick(item); }, className: classnames_1.default('tk-nav-item', { 'tk-nav-item--active': activeNavItemId === item.id }) }, item.label)); })))));
};
exports.default = exports.Nav;
